if (!customElements.get('mds-card-quantity')) {
  customElements.define('mds-card-quantity', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const input = this.querySelector('input[name="quantity"]');
      const minus = this.querySelector('[data-card-quantity-minus]');
      const plus = this.querySelector('[data-card-quantity-plus]');
      if (!input || !minus || !plus) return;
      this.initialized = true;
      const limits = () => ({min: Number(input.min) || 1, max: input.max ? Number(input.max) : Infinity, step: Number(input.step) || 1});
      const refresh = () => {
        const {min,max,step} = limits();
        minus.disabled = Number(input.value) - step < min;
        plus.disabled = Number(input.value) + step > max;
      };
      const normalize = () => {
        const {min,max,step} = limits();
        const value = input.value === '' ? min : Number(input.value);
        input.value = String(Math.max(min,Math.min(max,min + Math.round(((Number.isFinite(value) ? value : min) - min) / step) * step)));
        refresh();
      };
      const adjust = direction => {
        normalize();
        input.value = String(Number(input.value) + direction * limits().step);
        normalize();
        input.dispatchEvent(new Event('change',{bubbles:true}));
      };
      minus.addEventListener('click',() => adjust(-1));
      plus.addEventListener('click',() => adjust(1));
      input.addEventListener('input',refresh);
      input.addEventListener('change',normalize);
      // Normalize before the existing product form serializes this card's fields.
      input.form?.addEventListener('submit',normalize,true);
      normalize();
      if (this.classList.contains('mds-card-quantity--popup') && typeof HTMLDialogElement !== 'undefined') {
        const trigger = input.form?.querySelector('[data-js-product-add-to-cart]');
        trigger?.setAttribute('aria-haspopup','dialog');
        trigger?.setAttribute('aria-controls','MdsQuickQuantityDialog');
        trigger?.setAttribute('aria-expanded','false');
      }
    }
  });
}

(() => {
  if (window.mdsQuickQuantityPopupLoaded || typeof HTMLDialogElement === 'undefined') return;
  window.mdsQuickQuantityPopupLoaded = true;
  document.documentElement.classList.add('mds-quick-quantity-enabled');
  const language = document.documentElement.lang.split('-')[0];
  const labels = {
    de:{quantity:'Menge wählen',close:'Schließen'},
    it:{quantity:'Scegli la quantità',close:'Chiudi'},
    en:{quantity:'Choose quantity',close:'Close'}
  }[language] || {quantity:'Choose quantity',close:'Close'};
  const dialog = document.createElement('dialog');
  dialog.id = 'MdsQuickQuantityDialog';
  dialog.className = 'mds-quantity-popup';
  dialog.setAttribute('aria-labelledby','MdsQuickQuantityTitle');
  dialog.innerHTML = `<button type="button" class="mds-quantity-popup__close" data-quantity-popup-close>×</button>
    <div class="mds-quantity-popup__product"><img data-quantity-popup-image alt="" width="64" height="64"><div>
      <h2 id="MdsQuickQuantityTitle" class="mds-quantity-popup__title"></h2>
      <p class="mds-quantity-popup__subtitle" data-quantity-popup-subtitle></p>
      <p class="mds-quantity-popup__price" data-quantity-popup-price></p>
    </div></div>
    <p class="mds-quantity-popup__prompt" data-quantity-popup-prompt></p>
    <div data-quantity-popup-slot></div>
    <button type="button" class="button button--solid button--regular button--fullwidth" data-quantity-popup-confirm></button>`;
  dialog.querySelector('[data-quantity-popup-close]').setAttribute('aria-label',labels.close);
  dialog.querySelector('[data-quantity-popup-prompt]').textContent = labels.quantity;
  document.body.append(dialog);
  const authorized = new WeakSet();
  let active = null;
  const restore = (focus = true) => {
    const source = active;
    if (!source) return null;
    active = null;
    if (source.placeholder.isConnected) source.placeholder.replaceWith(source.control);
    else source.control.remove();
    source.button.setAttribute('aria-expanded','false');
    if (focus && source.button.isConnected) source.button.focus({preventScroll:true});
    return source;
  };
  const close = () => { dialog.close(); restore(); };
  dialog.querySelector('[data-quantity-popup-close]').addEventListener('click',close);
  dialog.addEventListener('close',() => { if (!dialog.open) restore(); });
  dialog.addEventListener('click',event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  const confirm = () => {
    if (!active) return;
    const input = active.control.querySelector('input[name="quantity"]');
    input.dispatchEvent(new Event('change',{bubbles:true}));
    if (!input.reportValidity()) return;
    const source = restore(false);
    dialog.close();
    if (!source.form.isConnected || source.button.disabled) return;
    authorized.add(source.form);
    // Submit the unchanged original product form with the chosen quantity.
    source.form.requestSubmit(source.button);
    authorized.delete(source.form);
  };
  dialog.querySelector('[data-quantity-popup-confirm]').addEventListener('click',confirm);
  dialog.addEventListener('keydown',event => {
    if (event.key === 'Tab') {
      const controls = [...dialog.querySelectorAll('button:not(:disabled),input:not(:disabled)')]
        .filter(element => element.getClientRects().length > 0);
      const first = controls[0], last = controls.at(-1);
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();first?.focus();
      }
    }
    if (event.key === 'Enter' && event.target.matches('input[name="quantity"]')) {
      event.preventDefault();
      confirm();
    }
  });
  document.addEventListener('submit',event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (authorized.has(form)) { authorized.delete(form); return; }
    const control = form.querySelector('mds-card-quantity.mds-card-quantity--popup');
    const button = form.querySelector('[data-js-product-add-to-cart]');
    if (!control || !button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (active || button.disabled || button.classList.contains('working')) return;
    const placeholder = document.createComment('quantity control');
    control.before(placeholder);
    active = {form,control,button,placeholder};
    dialog.querySelector('#MdsQuickQuantityTitle').textContent = control.dataset.popupTitle;
    const subtitle = dialog.querySelector('[data-quantity-popup-subtitle]');
    subtitle.textContent = control.dataset.popupSubtitle || '';
    subtitle.hidden = !subtitle.textContent;
    dialog.querySelector('[data-quantity-popup-price]').textContent = control.dataset.popupPrice || '';
    dialog.querySelector('[data-quantity-popup-confirm]').textContent = control.dataset.popupConfirm;
    const image = dialog.querySelector('[data-quantity-popup-image]');
    image.hidden = !control.dataset.popupImage;
    if (control.dataset.popupImage) image.src = control.dataset.popupImage;
    else image.removeAttribute('src');
    dialog.querySelector('[data-quantity-popup-slot]').append(control);
    button.setAttribute('aria-expanded','true');
    dialog.showModal();
    const input = control.querySelector('input[name="quantity"]');
    input.focus({preventScroll:true});
    input.select();
  },true);
})();
